import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUser_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUser_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetSTDUser: any[];
  GetSTDUser_dummy: any[];
  GetAllUserGroups: any[];
  GetAllUserGroups_dummy: any[];
  GetAllCustomers: any[];
  GetAllCustomers_dummy: any[];
  CreateUserWithPassword: string;
  CreateUserWithPassword_dummy: string;
  STDUsersSave: number;
  STDUsersSave_dummy: number;
  AddUserToRole: boolean;
  AddUserToRole_dummy: boolean;
  isComp640071Visible: "visible" | "hidden";
  isComp333629Visible: "visible" | "hidden";
  isComp516810Visible: "visible" | "hidden";
  isComp333442Visible: "visible" | "hidden";
  isComp213011Enabled: "enabled" | "disabled";
  isComp932954Enabled: "enabled" | "disabled";
  isComp154640Enabled: "enabled" | "disabled";
}

export class User_Form_ScreenBase extends React.PureComponent<
  IUser_Form_ScreenProps,
  any
> {
  user_form_109_value_kuikaSelectBoxRef: React.RefObject<any>;
  user_form_423029_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "194b5bc3-fd1d-44c3-99ec-8f436a3da95f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 696180, PropertyName: "value", Value: "Kullanıcı Form" },
        { Id: 636943, PropertyName: "value", Value: "Durum" },
        { Id: 863743, PropertyName: "value", Value: "Kullanıcı Email" },
        { Id: 213011, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 509751, PropertyName: "value", Value: "İsim" },
        { Id: 588777, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 372299, PropertyName: "value", Value: "Soyisim" },
        { Id: 328147, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 34245, PropertyName: "value", Value: "Şifre" },
        { Id: 932954, PropertyName: "placeholder", Value: "***********" },
        { Id: 406671, PropertyName: "value", Value: "Şifre Tekrar" },
        { Id: 154640, PropertyName: "placeholder", Value: "***********" },
        { Id: 869518, PropertyName: "value", Value: "Kullanıcı Grubu" },
        { Id: 109, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 318249, PropertyName: "value", Value: "Kullanıcı Şirketi" },
        { Id: 423029, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
        { Id: 53203, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.user_form_588777_value_kuikaTextInputRef = React.createRef();
    this.user_form_328147_value_kuikaTextInputRef = React.createRef();
    this.user_form_109_value_kuikaSelectBoxRef = React.createRef();
    this.user_form_423029_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      GetSTDUser: [],
      GetAllUserGroups: [],
      GetAllCustomers: [],
      isComp640071Visible: "hidden",
      isComp333629Visible: "hidden",
      isComp516810Visible: "hidden",
      isComp333442Visible: "hidden",
      isComp213011Enabled: "disabled",
      isComp932954Enabled: "disabled",
      isComp154640Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("user_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.User_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("user_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("user_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.User_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      user_form_89818_value:
        this.state.GetSTDUser?.at?.(0)?.status ?? undefined,
      user_form_213011_value:
        this.state.GetSTDUser?.at?.(0)?.email ?? undefined,
      user_form_588777_value: this.state.GetSTDUser?.at?.(0)?.name ?? undefined,
      user_form_328147_value:
        this.state.GetSTDUser?.at?.(0)?.surname ?? undefined,
      user_form_109_value:
        this.state.GetSTDUser?.at?.(0)?.userGroup ?? undefined,
      user_form_423029_value:
        this.state.GetSTDUser?.at?.(0)?.customerId ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  User_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp516810Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].usersCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].usersCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp333442Visible =
      (ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].usersEdit
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].usersEdit
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "User_Form",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  User_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersCreate
            : null
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersEdit
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.User_FormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  User_FormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.STDUserId ?? this.props.screenInputs.stduserid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSTDUser = result?.data.getSTDUser;
    formVars.user_form_89818_value = ReactSystemFunctions.value(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].status
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].status
        : null
    );
    formVars.user_form_213011_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].email
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].email
        : null
    );
    formVars.user_form_588777_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].name
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].name
        : null
    );
    formVars.user_form_328147_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].surname
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].surname
        : null
    );
    formVars.user_form_109_value =
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].userGroup
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].userGroup
        : null;
    formVars.user_form_109_options = stateVars.GetAllUserGroups;
    formVars.user_form_423029_value =
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].customerId
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].customerId
        : null;
    formVars.user_form_423029_options = stateVars.GetAllCustomers;
    stateVars.isComp640071Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp516810Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].usersCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].usersCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp333442Visible =
      (ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].usersEdit
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].usersEdit
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp213011Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp932954Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp154640Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetAllUserGroups = result?.data.getAllUserGroups;

    formVars.user_form_109_value =
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].userGroup
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].userGroup
        : null;
    formVars.user_form_109_options = stateVars.GetAllUserGroups;
    stateVars.GetAllCustomers = result?.data.getAllCustomers;

    formVars.user_form_423029_value =
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].customerId
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].customerId
        : null;
    formVars.user_form_423029_options = stateVars.GetAllCustomers;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.user_form_89818_value = ReactSystemFunctions.value(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].status
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].status
        : null
    );

    formVars.user_form_213011_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].email
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].email
        : null
    );

    stateVars.isComp213011Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.user_form_588777_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].name
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].name
        : null
    );

    formVars.user_form_328147_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].surname
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].surname
        : null
    );

    stateVars.isComp640071Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp932954Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp154640Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.user_form_109_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].userGroup
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].userGroup
        : null
    );

    stateVars.dataSource_109 =
      stateVars.GetAllUserGroups ?? this.state.GetAllUserGroups;
    stateVars.dataSource_109 =
      stateVars.GetAllUserGroups ?? this.state.GetAllUserGroups;
    stateVars.isComp333629Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "groupName"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("Müşteri", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.user_form_423029_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSTDUser !== undefined
        ? stateVars.GetSTDUser?.length > 0
          ? stateVars.GetSTDUser[0].customerId
          : null
        : this.state.GetSTDUser?.length > 0
        ? this.state.GetSTDUser[0].customerId
        : null
    );

    stateVars.dataSource_423029 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.dataSource_423029 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.isComp516810Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].usersCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].usersCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp333442Visible =
      (ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSTDUser !== undefined
            ? stateVars.GetSTDUser?.length > 0
              ? stateVars.GetSTDUser[0].id
              : null
            : this.state.GetSTDUser?.length > 0
            ? this.state.GetSTDUser[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].usersEdit
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].usersEdit
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  User_FormComponent_824675_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_932954_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_932954_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_588777_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_588777_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_328147_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_328147_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.CreateUserWithPassword =
      await ReactSystemFunctions.createUserWithPassword(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_213011_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_932954_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_588777_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_328147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true,
        "",
        ""
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick_if01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_if0f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_109_value",
          "value",
          "GetAllUserGroups",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_423029_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_588777_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_588777_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_328147_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_328147_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_109_value",
          "value",
          "GetAllUserGroups",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_109_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_423029_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Email_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_213011_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_588777_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Status_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_89818_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Surname_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_328147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserGroup_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.STDUserId ?? this.props.screenInputs.stduserid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_9544_onClick_if0f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDUsersSave = result?.data.stdUsersSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick_if0f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_if0f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("customer", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick_if0e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_588777_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_588777_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_328147_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_328147_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_109_value",
          "value",
          "GetAllUserGroups",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_109_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      Email_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_213011_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_588777_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Status_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_89818_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Surname_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_328147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserGroup_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.STDUserId ?? this.props.screenInputs.stduserid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_9544_onClick_if0e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDUsersSave = result?.data.stdUsersSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_9544_onClick_if0e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_9544_onClick_if0e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("manager", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "groupName"
          )
        ),
        "Müşteri"
      )
    ) {
      isErrorOccurred = await this.User_FormComponent_9544_onClick_if0f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.User_FormComponent_9544_onClick_if0e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  User_FormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_932954_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_154640_value",
            "value",
            "",
            "",
            ""
          )
        )
      )
    ) {
      isErrorOccurred = await this.User_FormComponent_9544_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  User_FormComponent_53203_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_109_value",
          "value",
          "GetAllUserGroups",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_423029_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_588777_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_588777_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_328147_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_328147_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_109_value",
          "value",
          "GetAllUserGroups",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_109_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_423029_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Email_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_213011_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_588777_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Status_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_89818_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Surname_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_328147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserGroup_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.STDUserId ?? this.props.screenInputs.stduserid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_53203_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDUsersSave = result?.data.stdUsersSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_53203_onClick_if01_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_53203_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("customer", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  User_FormComponent_53203_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_588777_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_588777_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_328147_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_328147_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_109_value",
          "value",
          "GetAllUserGroups",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_109_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      Email_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_213011_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_588777_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Status_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_89818_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Surname_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_328147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserGroup_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.STDUserId ?? this.props.screenInputs.stduserid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "User_Form/User_FormComponent_53203_onClick_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDUsersSave = result?.data.stdUsersSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.User_FormComponent_53203_onClick_else01_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  User_FormComponent_53203_onClick_else01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isValidEmail(
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Geçerli bir mail adresi giriniz.",
      formName: "user_form_213011_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("manager", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "user_form_213011_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  User_FormComponent_53203_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "groupName"
          )
        ),
        "Müşteri"
      )
    ) {
      isErrorOccurred = await this.User_FormComponent_53203_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.User_FormComponent_53203_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  User_FormComponent_109_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp333629Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "user_form_109_value",
            "value",
            "GetAllUserGroups",
            "id",
            "groupName"
          )
        ),
        "Müşteri"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["User_Form"] ?? false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.User_FormPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.User_FormPageInit();
    }
  }
}
